import { Navigate, Outlet } from 'react-router';
import { useAppSelector } from '@/store';
import { GET_AUTH_CONFIG } from '@/store/app/auth.slice.ts';
const AuthLayout = () => {
  const { isLoggedIn } = useAppSelector(GET_AUTH_CONFIG);
  if (isLoggedIn) {
    return <Navigate to="/admin" replace={true} />;
  }
  return (
    <section className="min-h-screen flex items-center justify-center">
      <div className="container">
        <div className="grid grid-cols-1">
          <div className="w-full max-w-[550px] mx-auto bg-white rounded-lg shadow-lg drop-shadow-2xl">
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthLayout;
